import { render, staticRenderFns } from "./cultural-item.vue?vue&type=template&id=02ec05b1&scoped=true"
import script from "./cultural-item.vue?vue&type=script&lang=js"
export * from "./cultural-item.vue?vue&type=script&lang=js"
import style0 from "./cultural-item.vue?vue&type=style&index=0&id=02ec05b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ec05b1",
  null
  
)

export default component.exports